import { render } from "./pc.vue?vue&type=template&id=22bbb637&ts=true"
import script from "./pc.vue?vue&type=script&lang=ts"
export * from "./pc.vue?vue&type=script&lang=ts"

import "./pc.vue?vue&type=style&index=0&id=22bbb637&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__